import React from 'react'
import TaskStudentFilter from '../../../../../Tasks/Filters/Students'
const StudentFilters = (props) => {
    return (
        <TaskStudentFilter {...props} />
    )
}

export default StudentFilters